import { render, staticRenderFns } from "./GreenProcessManagement.vue?vue&type=template&id=739537bc&scoped=true"
import script from "./GreenProcessManagement.vue?vue&type=script&lang=js"
export * from "./GreenProcessManagement.vue?vue&type=script&lang=js"
import style0 from "./GreenProcessManagement.vue?vue&type=style&index=0&id=739537bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739537bc",
  null
  
)

export default component.exports